import { render, staticRenderFns } from "./InboxListMainMenu.vue?vue&type=template&id=4d709c3d"
import script from "./InboxListMainMenu.vue?vue&type=script&lang=js"
export * from "./InboxListMainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports